import * as rmd from 'material-ui';
import React from 'react';
import TeamPicker from './TeamPicker';
import config from 'cfg';
import _ from 'lodash';

const POSITIONS_ORDER = ['keeper', 'defender', 'midfielder', 'forward'];

class PlayerPicker extends React.Component {
    constructor(props, context) {
        super(props, context);

        const playerKeyProperty = this.getPropertyFor(props.customKey ? props.propsMap.playerId : 'playerId');
        const teamKeyProperty = this.getPropertyFor(props.customKey ? props.propsMap.teamId : 'teamId');

        this.state = {
            playerKeyProperty,
            teamKeyProperty,
            //teamId: props[teamKeyProperty] && +props[teamKeyProperty] || this.props.teamId,
            teamId: this.props.hideTeamPicker ? this.props.teamId : props[teamKeyProperty] && +props[teamKeyProperty],
            playerId: props[playerKeyProperty] && +props[playerKeyProperty],
            players: [],
        };
    }

    componentDidMount() {
        this.handleTeamChange(null, this.state.teamId);
    }

    handleTeamChange = (key, value) => {
        var teamId = value;

        if (!_.isInteger(teamId)) {
            this.setState({ teamId: null, playerId: null, players: [] }, () => {
                this.props.onChange({ [this.state.teamKeyProperty]: null, [this.state.playerKeyProperty]: null });
            });
            return;
        }
        this.setState({ teamId });

        this.props.onChange(this.state.teamKeyProperty, teamId);

        return fetch(`${config.apis.ss2}/teams/${teamId}/members`)
            .then(response => response.status === 200 && response.json())
            .then(team => this.setState({ players: team.players }));
    };

    renderOption(pl) {
        var text = `${pl.number || ''}. ${pl.name}`;

        return <rmd.MenuItem key={pl.id} value={pl.id} primaryText={text} />;
    }

    handlePlayerChange = (e, key, val) => {
        this.setState({ playerId: val }, () => {
            this.props.onChange(this.state.playerKeyProperty, val);
        });
    };

    getPropertyFor(key) {
        return _.get(this, `props.propsMap[${key}]`, key);
    }

    render() {
        var playersOptions = _.orderBy(this.state.players, [pl => POSITIONS_ORDER.indexOf(pl.position), 'number']);

        return (
            <div>
                {!this.props.hideTeamPicker && (
                    <TeamPicker
                        onChange={this.handleTeamChange}
                        tournamentId={this.props.tournamentId}
                        teamId={this.state.teamId}
                    />
                )}
                <rmd.SelectField
                    floatingLabelText="Players"
                    floatingLabelFixed
                    value={this.state.playerId}
                    disabled={!this.state.teamId}
                    maxHeight={400}
                    onChange={this.handlePlayerChange}
                >
                    <rmd.MenuItem key="zero" value={null} primaryText="Any" />
                    {playersOptions.map(this.renderOption)}
                </rmd.SelectField>
            </div>
        );
    }
}

export default PlayerPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/PlayerPicker.js
 **/